import { render, staticRenderFns } from "./mobile-product-info.vue?vue&type=template&id=1272b42b&scoped=true&"
import script from "./mobile-product-info.vue?vue&type=script&lang=js&"
export * from "./mobile-product-info.vue?vue&type=script&lang=js&"
import style0 from "./mobile-product-info.vue?vue&type=style&index=0&id=1272b42b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1272b42b",
  null
  
)

/* custom blocks */
import block0 from "../locales.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fgitlab-runner%2Fbuilds%2F7624f89f%2F0%2Ftokyo-auction%2Ftokyo-auction-frontend%2Fsrc%2Fviews%2Fproducts%2Fcomponents%2Fmobile-product-info.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports